import { render, staticRenderFns } from "./LiteratureContext.vue?vue&type=template&id=57b6c162&"
import script from "./LiteratureContext.vue?vue&type=script&lang=ts&"
export * from "./LiteratureContext.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports